import React, { useCallback, useContext, useEffect, useState } from "react";

import {
  Grid,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { CrowdinFileData } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/translations_pb";

import TanslationRecord from "../components/seo-templates/translation-record";
import UploadTranslationForm from "../components/seo-templates/upload-translation-form";
import { DEFAULT_REGION_CODE } from "../constants/index";
import { getCrowdinProjectFiles } from "api/endpoints/seo-templates";
import { callOptionsHeaders } from "api/helpers";
import SeoInformationCard from "components/seo-templates/seo-information-card";
import { SnackbarContext } from "context/snackbar-context";

const SeoTemplates = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [crowdinList, setCrowdinList] = useState<CrowdinFileData[]>([]);
  const { showError } = useContext(SnackbarContext);

  const getCrowdinFileList = useCallback(() => {
    setIsLoading(true);

    getCrowdinProjectFiles(callOptionsHeaders(DEFAULT_REGION_CODE))
      .then((projectFiles) => {
        setCrowdinList(projectFiles.files);
      })
      .catch(showError)
      .finally(() => {
        setIsLoading(false);
      });
  }, [showError]);

  useEffect(() => {
    getCrowdinFileList();
  }, [getCrowdinFileList]);

  const crowdinFileRecord = (row: CrowdinFileData, index: number) => {
    const translationStatus = row.translationStatus;

    return (
      <TableRow key={`${index}-${row.fileId}`}>
        <TableCell align="left" style={{ verticalAlign: "top" }}>
          {row.fileTitle}
          <br />
        </TableCell>
        <TableCell align="left" style={{ verticalAlign: "top" }}>
          {row.directoryName}
        </TableCell>
        <TableCell>
          {translationStatus.map((status) => (
            <TanslationRecord
              key={row.fileId}
              row={status}
              crowdinFileId={row.fileId}
              getCrowdinFileList={getCrowdinFileList}
            />
          ))}
        </TableCell>
      </TableRow>
    );
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} style={{ paddingBottom: "20px" }}>
          <Grid container alignContent="space-between" alignItems="center">
            <Grid item xs={12}>
              <Typography
                variant="h5"
                color="textPrimary"
                gutterBottom
                data-testid="seo-templates-title"
              >
                SEO Template Translations
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <UploadTranslationForm getCrowdinFileList={getCrowdinFileList} />

        <Grid item xs={12} style={{ paddingBottom: "20px" }}>
          <Grid container alignContent="space-between" alignItems="center">
            <SeoInformationCard />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table aria-label="crowndin-templates">
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    <b>Template Name</b>
                  </TableCell>
                  <TableCell align="left">
                    <b>Crowdin Directory</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>Language Status</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={4}>
                      <LinearProgress />
                    </TableCell>
                  </TableRow>
                ) : (
                  crowdinList.map((row, index) => crowdinFileRecord(row, index))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </>
  );
};

export default SeoTemplates;
